module.exports = __webpack_public_path__ + "static/img/12areaA_06.3ce5667.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/12areaA_06.png
// module id = 997
// module chunks = 1